<div id="fadeShare"></div>
<div id="modalShare">
    <img style="margin-bottom:10px;" id="loader" src="/Cache/images/icon_load.gif" /><br />
    <label>Please wait while the page is processing...</label>
</div>

<router-outlet></router-outlet>
